var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { staticStyle: { padding: "10px", "background-color": "#ffffff" } },
    [
      _c("el-col", { attrs: { span: 24 } }, [
        _c(
          "div",
          {
            staticStyle: {
              border: "4px solid #cccccc",
              "border-radius": "30px",
              padding: "20px"
            }
          },
          [
            _c(
              "el-row",
              [
                _c(
                  "el-col",
                  { staticClass: "center-col", attrs: { span: 24 } },
                  [
                    _c("span", { staticClass: "property-selection-title" }, [
                      _vm._v("Select your new property")
                    ])
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              { staticStyle: { "margin-top": "15px" } },
              [
                _c(
                  "el-col",
                  {
                    staticClass: "center-col",
                    staticStyle: { "margin-top": "10px" },
                    attrs: { span: 24 }
                  },
                  [
                    _c("span", { staticClass: "property-selection-desc" }, [
                      _vm._v(
                        "\n            Congratulations on selecting your brand-new property!\n          "
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  {
                    staticClass: "center-col",
                    staticStyle: { "margin-top": "10px" },
                    attrs: { span: 24 }
                  },
                  [
                    _c("span", { staticClass: "property-selection-desc" }, [
                      _vm._v(
                        "Take advantage of UNIFI Property’s unique online reservation\n            function to reserve this property\n          "
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  {
                    staticClass: "center-col",
                    staticStyle: { "margin-top": "10px" },
                    attrs: { span: 24 }
                  },
                  [
                    _c("span", { staticClass: "property-selection-desc" }, [
                      _vm._v(
                        "exclusively for you, for the next 7 days\n          "
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  {
                    staticClass: "center-col",
                    staticStyle: { "margin-top": "10px" },
                    attrs: { span: 24 }
                  },
                  [
                    _c("span", { staticClass: "property-selection-desc" }, [
                      _vm._v(
                        "\n            To start the process, select which of the available properties you\n            would like to reserve\n          "
                      )
                    ])
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              { staticStyle: { "margin-top": "20px" }, attrs: { gutter: 20 } },
              [
                _c("el-col", { attrs: { span: 8 } }, [
                  _c(
                    "span",
                    { staticClass: "label-available full-width text-style" },
                    [_vm._v("Available"), _c("br"), _vm._v("Properties")]
                  )
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 8 } }, [
                  _c(
                    "span",
                    { staticClass: "label-sold full-width text-style" },
                    [_vm._v("Sold"), _c("br"), _vm._v("Properties")]
                  )
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 8 } }, [
                  _c(
                    "span",
                    { staticClass: "label-reserved full-width text-style" },
                    [_vm._v("Reserved"), _c("br"), _vm._v("Properties")]
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              {
                staticStyle: {
                  "margin-top": "10px",
                  display: "flex",
                  "justify-content": "center",
                  "flex-wrap": "wrap"
                },
                attrs: { gutter: 20 }
              },
              _vm._l(_vm.datum, function(item, index) {
                return _c(
                  "el-col",
                  { key: index, staticClass: "prop-tile", attrs: { span: 12 } },
                  [
                    _c(
                      "span",
                      {
                        class: {
                          "btn-prop-res": true,
                          reserved: item.status == "Reserved",
                          sold:
                            item.status == "Sold" ||
                            item.status == "Unconditional" ||
                            item.status == "Settled",
                          available: item.status == "Available",
                          choosed: index == _vm.cur
                        },
                        on: {
                          click: function($event) {
                            return _vm.choosed(index, item.roomId, item.status)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n            " + _vm._s(item.apt) + "\n          "
                        )
                      ]
                    )
                  ]
                )
              }),
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              { staticStyle: { "margin-top": "20px" } },
              [
                _c(
                  "el-col",
                  {
                    staticStyle: {
                      display: "flex",
                      "flex-direction": "column"
                    },
                    attrs: { span: 24 }
                  },
                  [
                    _c(
                      "el-button",
                      {
                        class: {
                          "selection-continue disabled":
                            _vm.datum.length === 0 || _vm.cur === -1,
                          "selection-continue":
                            _vm.datum.length > 0 && _vm.cur !== -1
                        },
                        attrs: {
                          disabled: _vm.datum.length === 0 || _vm.cur === -1
                        },
                        on: { click: _vm.reservePropertyForm }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.buyNoworMakeOfferBtn) + "\n          "
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e4419d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e4419d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservation/propertySelection.vue
// module id = null
// module chunks = 